import { render } from "./AnnouncementsBar.vue?vue&type=template&id=dc08a4ac&scoped=true"
import script from "./AnnouncementsBar.vue?vue&type=script&lang=js"
export * from "./AnnouncementsBar.vue?vue&type=script&lang=js"

import "./AnnouncementsBar.vue?vue&type=style&index=0&id=dc08a4ac&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dc08a4ac"]])

export default __exports__